import React, { useState } from 'react';
 
interface DonateModalProp {
    isOpen: Boolean,
    onClose: () => void
}


export const DonateModal:React.FC<DonateModalProp> = ({ isOpen, onClose }) => {
    const [isCopied, setCopied] = useState(false)

    if (!isOpen) return null;

    const copyToClipboard = (text:string) => {
        navigator.clipboard.writeText(text);
        setCopied(true)
        setTimeout(() => setCopied(false), 5000)
    }

  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-[#5a3642] p-6 rounded-2xl shadow-lg  mx-3 w-full max-w-md">
          <div className="flex justify-between items-center border-b pb-2">
            <h2 className="text-xl font-bold text-white">Support Our Cause By Donating</h2>
            <button onClick={onClose} className="text-gray-500 hover:text-black">&times;</button>
          </div>
          <div className="py-4 text-base text-white">
            <small>Your donation helps us continue our mission. Any amount is appreciated!</small>
            <div className='mt-4 space-y-2'>
            <p><strong>Account Name:</strong> &nbsp;Abiyamo ^Aboja</p>
            <p><strong>Bank Name:</strong> &nbsp;Zenith Bank</p>
            <p onClick={() => copyToClipboard('1019722017')}>
                <strong>Account Number:</strong> &nbsp; 1019722017 &nbsp;
                <small onClick={() => copyToClipboard('1019722017')} className='text-xs cursor-pointer'>
                    {
                        isCopied ? "copied" : "tap to copy"
                    }
                </small>
            </p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  